<template>

    <el-dialog custom-class="shift_bulk_remove_modal" v-model="modalVisible" :title="dialogTitle" @open="openModal"
        @close="closeModal" destroy-on-close :append-to-body="true">
        <div class="text-right">
            <el-button @click="toggleSelectAll" class="mb-2 select-all">{{ selectAllText }}</el-button>
        </div>
        <template v-for="(shift) in job.shifts" :key="shift.date">
            <div class="job_shift_item1" >
                <div class="job_shift_info1">
                  
                    <el-checkbox class="c-label" :disabled="isShiftDisabled(shift.status)" :label="shift.id" v-model="selectedShifts" v-if="userRole === 'locum'" @change="toggleBulkShiftSelect"></el-checkbox>
                    <el-checkbox class="c-label" :disabled="isShiftDisabled(shift.status)" :label="shift.id" v-model="selectedShifts" v-if="userRole === 'pharmacy'"></el-checkbox>
                    <div class="job_shift_text">
                        <div class="job_shift_user1">
                            <template v-if="shift.locum">
                                <el-avatar :size="30" shape="square" :src="shift.locum.image"
                                    v-if="shift.locum.image" />
                                <el-avatar :size="30" class="avatar-d" shape="square"
                                    icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                            </template>
                            <template v-else>
                                <el-avatar :size="30" class="avatar-d gray" shape="square"
                                    icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"></el-avatar>
                            </template>

                        </div>
                        <div class="day_info">
                            <div class="day_name header">
                                <!-- {{ $moment(shift.date, "YYYY/MM/DD").format("ddd") }},
                                {{ $moment(shift.date, "YYYY/MM/DD").format("D MMM, YYYY") }} -->
                                <div class="day" v-if="isAustralia">
                                  {{
                                    $moment(shift.date, "YYYY/MM/DD").format("dddd,")
                                  }}
                                  {{
                                    $moment(shift.date, "YYYY/MM/DD").format(
                                      "DD MMM YYYY"
                                    )
                                  }}
                                </div>
                                <div class="day" v-else>
                                  {{
                                    $moment(shift.date, "YYYY/MM/DD").format("dddd,")
                                  }}
                                  {{
                                    $moment(shift.date, "YYYY/MM/DD").format(
                                      "MMM DD YYYY"
                                    )
                                  }}
                                </div>
                            </div>
                            <!-- <div class="day_time data">
                                <span>{{ $moment(shift.userStartTime || shift.startTime, "HH:mm").format("h:mm A")}}</span>
                                -
                                <span>{{ $moment(shift.userEndTime || shift.endTime, "HH:mm").format("h:mm A") }}</span>
                            </div> -->
                        </div>

                        <div class="info-wrapper">
                          <div class="day_info_block">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.40001 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.40001 18.3333 10Z"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8417 9.69167 10.2 9.69167 9.675V6.25833"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <div class="day_time data">
                              <span>{{
                                $moment(
                                  shift.userStartTime || shift.startTime,
                                  "HH:mm"
                                ).format("h:mm A")
                              }}</span>
                              -
                              <span>{{
                                $moment(
                                  shift.userEndTime || shift.endTime,
                                  "HH:mm"
                                ).format("h:mm A")
                              }}</span
                              >&nbsp;
                              <span v-if="showShiftInformation(shift)">
                                ({{
                                  confirmedHours(
                                    shift.confirmedHours,
                                    shift.startTime,
                                    shift.endTime
                                  )
                                }}
                                Hours)</span
                              >
                              <span v-else>-</span>
                            </div>
                          </div>

                          <div class="day_info_block">
                            <div class="title">
                              <!-- <span>Break </span> -->
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 18.3333C5.975 18.3333 2.70833 15.0667 2.70833 11.0417C2.70833 7.01667 5.975 3.75 10 3.75C14.025 3.75 17.2917 7.01667 17.2917 11.0417"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 6.66699V10.8337"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M7.5 1.66699H12.5"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M15.8334 14.167V17.5003"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M13.3334 14.167V17.5003"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div class="info">
                              <span v-if="showShiftInformation(shift)">
                                {{
                                  shift.userBreakMinutes
                                    ? getTimeFromMinutes(shift.userBreakMinutes)
                                    : "-"
                                }}</span
                              >
                              <span v-else>-</span>
                            </div>
                          </div>

                          <div class="day_info_block"
                            v-if="
                              !shift.shiftBookedAsInternalStaff &&
                              shift.isVisibileAsInternalLocum === false
                            "
                          >
                            <div class="title">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                />
                                <path
                                  d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                />
                                <path
                                  d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4.57185 4.58366H4.58148"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M15.4052 14.5837H15.4148"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div
                              class="info"
                              v-if="job.settings.payingForTravel == 3 &&
                                job.maxTravelCompensation !== 0
                              "
                            >
                              <span>Capped Travel</span>
                            </div>
                            <div class="info" v-else>
                              <span>Travel</span>
                            </div>
                            <div class="info">
                              <span v-if="showShiftInformation(shift)">
                                {{ travelCompensationCount(job, shift) }}
                              </span>
                              <span v-else>-</span>
                            </div>
                          </div>

                          <div
                            class="day_info_block"
                            v-if="
                              !shift.shiftBookedAsInternalStaff ||
                              shift.isVisibileAsInternalLocum === false
                            "
                          >
                            <div class="title">
                              <!-- <span>Rate</span> -->
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 5V15"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <span
                                class="locumate_icons locumate_icon-check shift_confirm"
                                v-if="shift.confirmationDate"
                              ></span>
                            </div>
                            <div class="info rate">
                              <span
                                v-if="
                                  (showShiftInformation(shift) &&
                                    !shift.shiftBookedAsInternalStaff) ||
                                  (showShiftInformation(shift) &&
                                    job.openMarketplaceShiftForInternalLocum)
                                "
                                >{{ Rate(shift) }}</span
                              >
                              <span v-else>-</span>
                            </div>
                          </div>
                          <template v-if="isAustralia">
                            <div
                              class="day_info_block"
                              v-if="
                                !shift.shiftBookedAsInternalStaff ||
                                shift.isVisibileAsInternalLocum === false
                              "
                            >
                              <div class="title">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                                    stroke="rgb(var(--locumate-primary-color-dark))"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10 5V15"
                                    stroke="rgb(var(--locumate-primary-color-dark))"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                <!-- <span>Total Super</span> -->
                              </div>
                              <div class="info amount">
                                <span>Total Super</span>
                                <span
                                  v-if="
                                    (showShiftInformation(shift) &&
                                      !shift.shiftBookedAsInternalStaff) ||
                                    (showShiftInformation(shift) &&
                                      job.openMarketplaceShiftForInternalLocum)
                                  "
                                >
                                  {{ totalSuperRate(shift) }}</span
                                >
                                <span v-else>-</span>
                              </div>
                            </div>
                          </template>

                          <div
                            class="day_info_block"
                            v-if="
                              !shift.shiftBookedAsInternalStaff ||
                              shift.isVisibileAsInternalLocum === false
                            "
                          >
                            <div class="title">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 5V15"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                                  stroke="rgb(var(--locumate-primary-color-dark))"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <!-- <span>Sum</span> -->
                            </div>
                            <div class="info amount">
                              <span>Sum </span>
                              <span
                                v-if="
                                  (showShiftInformation(shift) &&
                                    !shift.shiftBookedAsInternalStaff) ||
                                  (showShiftInformation(shift) &&
                                    job.openMarketplaceShiftForInternalLocum)
                                "
                              >
                                {{ Sum(shift) }}</span
                              >
                              <span v-else>-</span>
                            </div>
                          </div>
                          
                        </div>

                    </div>
                </div>
            </div>
           
        </template>
        <span class="d-flex mb-1" style="font-size: 16px;">Please choose your cancellation reason:</span>
            <div class="dialog-element">
                <el-select v-model="dialog.cancel.reasonType" placeholder="Choose an option" popper-class="normal-select">
                <el-option v-for="item in dialog.cancel.options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </div>

            <div class="dialog-element" v-if="dialog.cancel.reasonType === 3">
                <el-input maxlength="255" show-word-limit v-model="dialog.cancel.description" :rows="4" type="textarea"
                placeholder="Please state your reason" />
            </div>
        <template #footer>

                <el-button class="submit_page sub w-full danger" type="red" @click="actions.removeShift()"
                    :disabled="removeButtonDisabled">
                    Remove Shifts
                </el-button>

        </template>
    </el-dialog>

</template>

<script>
import { ref, inject, computed  } from "vue";
import moment from "moment";
import { useStore } from "vuex";
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import { useRouter } from "vue-router";
import timeDiff from "@/helpers/date/timeDiff";
import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
import { isAustraliaRegion } from "@/helpers/region/regionHelper.js";

export default {
    props: {
        modalName: {
            type: String,
        },
        options: {
            type: Object,
        },
    },
    setup(props) {
        const $store = useStore();
        const $router = useRouter();
        const $mitt = inject("$mitt");
        const modalVisible = ref(false);
        const bottomDropUp = ref([]);
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const $moment = inject(["$moment"]);
        const selectedShifts = ref([]);
        const searchTerm = ref("");
        const selectAll = ref(false);
        const isAustralia = isAustraliaRegion();
        // const showAwardShiftDialog = ref(false);
        const closeModal = () => {
            modalVisible.value = false;
            dialog.value.cancel.reasonType = null;
            dialog.value.cancel.description = null;
        };
        $mitt.on(props.modalName, (options) => {
            modalVisible.value = options.show;
        });


        function formatDate(date) {
          return $moment(date, "YYYY-MM-DD").format("dddd, D MMMM");
        }

        // const openModal = () => {};
        const dialogTitle = computed(() => {
            return `${checkJobDateStart(job.value.startDate, job.value.endDate, true)}`;
        });


        const isSelected = (applicantId) => {
            return selectedShifts.value.includes(applicantId);
        };


        const actions = {
            removeShift() {

                (async () => {
                    try {
                        let formattedDates = null;
                        if (job.value.isBlockShift == 1) {
                            let response = await $store.dispatch("GET_BLOCK_SHIFT_SHIFTS", {
                                shiftId: shift.value.id,
                            });

                            formattedDates = response.data.shifts
                                
                                .map((shift) =>
                                    $moment(shift.date, "YYYY-MM-DD").format("D MMM, YYYY")
                                )
                                .join(", ");
                        }

                        (async () => {
                            try {
                                if (job.value.isBlockShift == 1) {
                                  let alertMessageHtml = `Are you sure you’d like to remove shifts for following ${formattedDates} dates?`;
                                  if (job.value.shifts.length > 1) {
                                        alertMessageHtml = `<div class="cancel-message">
                                      Are you sure you would like to remove the following shift${selectedShifts.value.length > 1 ? "(s)" : ""}?
                                      <ul>`;
                                        job.value.shifts
                                        .filter(shift => selectedShifts.value.includes(shift.id))
                                        .forEach((shift) => {
                                          alertMessageHtml += `<li><span class="day">${formatDate(shift.date)}</span><span class="time">${
                                            shift.startTime
                                          } - ${shift.endTime}</span></li>`;
                                        });
                                        alertMessageHtml += `</ul></div>`;
                                      }
                                    await ElMessageBox.confirm(
                                      alertMessageHtml,
                                        "Remove shift",
                                        {
                                            confirmButtonText: "Remove",
                                            cancelButtonText: "Cancel",
                                            confirmButtonClass: "el-button--red",
                                            cancelButtonClass: "el-button--grey",
                                            showClose: false,
                                            dangerouslyUseHTMLString: true,
                                            customClass: "remove-shift-modal",
                                        }
                                    );
                                } else {
                                    await ElMessageBox.confirm(
                                        `Are you sure you’d like to remove shift for ${$moment(
                                            shift.value.date,
                                            "YYYY/MM/DD"
                                        ).format("D MMM, YYYY")}`,
                                        "Remove shift",
                                        {
                                            confirmButtonText: "Remove",
                                            cancelButtonText: "Cancel",
                                            confirmButtonClass: "el-button--red",
                                            cancelButtonClass: "el-button--grey",
                                            showClose: false,
                                        }
                                    );
                                }

                                await (async () => {
                                    try {
                                        const reason = getCancellationReason();
                                        console.log("🚀 ~ await ~ reason:", reason)
                                        await $store.dispatch("REMOVE_SELECTED_SHIFT_FROM_BULK_SHIFT", {
                                            shift_ids: selectedShifts.value,
                                            reason: reason,
                                            job_id:job.value.id
                                            });

                                        ElMessage({
                                            type: "success",
                                            message: "Shift removed successfully",
                                        });
                                        // fillCalendarMonth(true);
                                        selectedShifts.value = [];
                                        let checkRemainShifts = null;
                                        if (job.value.isBlockShift == 1) {
                                              console.log("🚀 ~ await ~ job.value.isBlockShift:", job.value);
                                              const response = await $store.dispatch(
                                                  "GET_JOB_INFO_DETAILS",
                                                  {
                                                    jobId: job.value.id,
                                                    params: {
                                                      with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                                                    },
                                                  }
                                                );
                                                console.log("🚀 ~ await ~ jobsdsd23232323232.value.isBlockShift:", response);
                                              checkRemainShifts = response.data.shifts;

                                              $store.dispatch("clearJobDetails");
                                              $store.dispatch("setJobDetails", {
                                                job: response.data,
                                              });
                                              console.log("🚀 ~ await ~ checkRemainShifts:", checkRemainShifts);
                                           }
                                           closeModal();
                                           if(checkRemainShifts.length){

                                            $router.replace({
                                                name: "job_days",
                                                params: {
                                                    jobId: job.value.id,
                                                },
                                            });

                                           }else{
                                             $router.push({
                                                 name: "search",
                                             });
                                           }

                                    } catch (error) {
                                        ElMessage({
                                            type: "info",
                                            message: "Shift did not removed",
                                        });
                                        console.log("error submit!!");
                                    }
                                })();
                            } catch (error) {
                                console.log(error);
                            }
                        })();
                    } catch (error) {
                        console.log("error submit!!", error);
                    }
                })();
            },
        }
        const checkJobDateStart = (dateStart, endDate, trim) => {
            let start = moment(dateStart, "YYYY/MM/DD");
            let end = moment(endDate, "YYYY/MM/DD");
            if (start.format("MMMM") == end.format("MMMM")) {
                if (start.format("D") == end.format("D")) {
                    return start.format("D " + (trim ? "MMM" : "MMMM"));
                }
                return (
                    start.format("D ") +
                    " - " +
                    end.format("D " + (trim ? "MMM" : "MMMM"))
                );
            } else {
                return (
                    start.format("D " + (trim ? "MMM" : "MMMM")) +
                    " - " +
                    end.format("D " + (trim ? "MMM" : "MMMM"))
                );
            }
        };

        const job = computed(() => {
            return props.options.job;
        });

        const shift = computed(() => {
            console.log("12313213213", props.options.job.shifts);
            return props.options.job.shifts[0];
        });

        const selectedShiftPass = computed(() => {
          
            return props.options.selectedShift;
        });

        const bottomDropUpClose = (i) => {
            bottomDropUp.value[i] = false;
        };


        const openModal = () => {
          console.log("hello rr");

            const shiftJob = { ...job.value.shifts }
            console.log("🚀 ~ openModal ~ shiftJob:", shiftJob)
            if(job.value?.shifts?.length > 0){
              selectAll.value = true;
            }
          if(userRole == "pharmacy"){
            if(!isShiftDisabled(selectedShiftPass.value.status)){
              selectedShifts.value = [selectedShiftPass.value.id];
              selectAll.value = false;
            }

          }else{
            job.value.shifts.forEach((shift) => {
                if (!isShiftDisabled(shift.status)) {
                    selectedShifts.value.push(shift.id);
                }
            });
          }
        };

        const clearSearchTerm = () => {
            searchTerm.value = "";
        };

        const showShiftInformation = (shift) => {
            if (userRole === "pharmacy") return true;
            if (!shift.userId) return true;
            if (shift.userId === userData.id) return true;
            return false;
        };

        const Rate = (shift) => {
            if (userRole === "pharmacy") {
                return shift.payRateExecSuper
                    ? new Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                    }).format(shift.payRateExecSuper)
                    : "-";
            } else {
                if (shift.locum == null && shift.payRateExecSuper == null) {
                    return Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                    }).format(shift.recommendedRate);
                } else {
                    return Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                    }).format(shift.payRateExecSuper);
                }
            }
        };

        const confirmedHours = (confirmedHours, startTime, endTime) => {
            let result;
            if (confirmedHours == 0) {
                const start = moment(startTime, "HH:mm:ss");
                const end = moment(endTime, "HH:mm:ss");

                result = timeDiff(start, end);
            } else {
                const string = String(confirmedHours);
                const hours = string.split(".")[0];
                let minutes = string.split(".")[1];
                if (!minutes) {
                    const time = hours + ":" + "00";
                    result = String(time);
                } else {
                    minutes = Number.parseFloat(`0.${minutes}`) * 60;
                    result = hours + ":" + minutes.toFixed(0);
                }
            }

            return result;
        };

        const getTimeFromMinutes = (mins) => {
            if (mins >= 24 * 60 || mins < 0) {
                throw new RangeError(
                    "Valid input should be greater than or equal to 0 and less than 1440."
                );
            }
            var h = (mins / 60) | 0,
                m = mins % 60 | 0;

            return moment.utc().hours(h).minutes(m).format("HH:mm");
        };

        const travelCompensationCount = (job, shift) => {
            if (
                (shift.travelCompensation >= 0 &&
                    shift.adminUpdatedTravelCompensation == true) ||
                (shift.travelCompensation === 0 &&
                    shift.adminUpdatedTravelCompensation == true)
            ) {
                const convertedTravelRate = formatCurrency(shift.travelCompensation);
                return convertedTravelRate;
            } else {
                if (
                    job.settings.payingForTravel === 0 &&
                    shift.adminUpdatedTravelCompensation == false
                ) {
                    return "-";
                }
            }

            if (
                job.settings.payingForTravel === 3 &&
                job.maxTravelCompensation !== 0
            ) {
                let travelCompensation;
                const globalTravelCompensationValue =
                    process.env.VUE_APP_TRAVEL_COMPENSATION;
                const jobDistance = shift.distance ? shift.distance : null;

                if (jobDistance) {
                    let distance = jobDistance;
                    travelCompensation = distance * 2 * globalTravelCompensationValue;
                    if (travelCompensation > job.maxTravelCompensation) {
                        const convertedTravelRate = formatCurrency(
                            job.maxTravelCompensation
                        );
                        return convertedTravelRate;
                    } else {
                        travelCompensation = new Intl.NumberFormat("en-AU", {
                            style: "currency",
                            currency: "AUD",
                        }).format(distance * 2 * globalTravelCompensationValue);
                        return travelCompensation;
                    }
                } else {
                  let maxTravelCompensation = job.maxTravelCompensation;
                    if(shift.status === 0 && userRole === 'pharmacy') {
                      
                      let enableTravelAllowanceForFirstAndLastDay = job.enableTravelAllowanceForFirstAndLastDay;
                      if(enableTravelAllowanceForFirstAndLastDay == 1 && shift.adminUpdatedTravelCompensation !== true){
                        if(!isNaN(maxTravelCompensation)){//is numeric
                          maxTravelCompensation = maxTravelCompensation / 2;
                        }
                        if (shift.date !== job.startDate && shift.date !== job.endDate) {
                          maxTravelCompensation = 0;
                        }
                      
                      
                      }
                     
                    }
                    const convertedTravelRate = formatCurrency(maxTravelCompensation);
                    return convertedTravelRate;
                }
            } else {
                const convertedTravelRate = formatCurrency(+shift.travelCompensation);
                return convertedTravelRate;
            }
        };

        const Sum = (shift) => {
            const globalTravelCompensationValue =
                process.env.VUE_APP_TRAVEL_COMPENSATION;

            let Sum;
            let confirmedHoursVal;
            let payRate;
            let travelCompensation;
            if (userRole === "locum") {
                if (shift.locum == null && shift.payRateExecSuper == null) {
                    payRate = shift.recommendedRate;
                } else {
                    payRate = shift.payRateExecSuper;
                }
            } else {
                payRate = shift.payRateExecSuper;
            }
            if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
                const start = moment(shift.startTime, "HH:mm:ss");
                const end = moment(shift.endTime, "HH:mm:ss");

                confirmedHoursVal = timeDiffAsDecimal(start, end);
            } else {
                confirmedHoursVal = shift.confirmedHours;
            }

            if (
                shift.travelCompensation === 0 &&
                shift.adminUpdatedTravelCompensation == false
            ) {
                const jobDistance = shift.distance ? shift.distance : null;
                // const jobDistance = job.value.distance.replace(',', '.').split(" ")[0];

                if (jobDistance) {
                    let distance = jobDistance;

                    if (job.value.settings.payingForTravel == 1) {
                        if (distance * 2 > 50) {
                            travelCompensation =
                                (distance * 2 - 50) * globalTravelCompensationValue;
                        } else {
                            travelCompensation = shift.travelCompensation;
                        }
                    } else if (job.value.settings.payingForTravel == 2) {
                        travelCompensation = distance * 2 * globalTravelCompensationValue;
                    } else if (
                        job.value.settings.payingForTravel === 3 &&
                        job.value.maxTravelCompensation !== 0
                    ) {
                        let realTravelCost = distance * 2 * globalTravelCompensationValue;
                        if (realTravelCost > job.value.maxTravelCompensation) {
                            travelCompensation = job.value.maxTravelCompensation;
                        } else {
                            travelCompensation = distance * 2 * globalTravelCompensationValue;
                        }
                    }
                } else {
                    travelCompensation = shift.travelCompensation;
                }

                if (!job.value.settings.payingForTravel) {
                    travelCompensation = 0;
                }
            } else {
                travelCompensation = shift.travelCompensation;
            }

            // if (!job.value.settings.payingForTravel) {
            //   travelCompensation = 0;
            // }

            if (payRate != null) {
                Sum = payRate * confirmedHoursVal + travelCompensation;
            } else {
                Sum = 0;
            }

            if (Sum != 0) {
                Sum = new Intl.NumberFormat("en-AU", {
                    style: "currency",
                    currency: "AUD",
                }).format(Sum);
            } else {
                Sum = "-";
            }
            return Sum;
        };

        const totalSuperRate = (shift) => {
            let confirmedHoursVal = 0;

            if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
                const start = moment(shift.startTime, "HH:mm:ss");
                const end = moment(shift.endTime, "HH:mm:ss");

                confirmedHoursVal = timeDiffAsDecimal(start, end);
            } else {
                confirmedHoursVal = shift.confirmedHours;
            }

            const superRate = shift.payRateSuper * confirmedHoursVal;

            return superRate
                ? Intl.NumberFormat("en-AU", {
                    style: "currency",
                    currency: "AUD",
                }).format(superRate)
                : "-";
        };

        const formatCurrency = (rate) => {
            return new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
            }).format(rate);
        };


        const toggleSelectAll = () => {
            // If any shift is unselected, select all available shifts
            if (selectedShifts.value.length === job.value.shifts.filter(shift => !isShiftDisabled(shift.status)).length) {
                // All are selected, unselect them
                selectedShifts.value = [];
                selectAll.value = false;
            } else {
                // If not all are selected, select all available shifts
                selectedShifts.value = job.value.shifts
                    .filter(shift => !isShiftDisabled(shift.status)) // Only include shifts where status is less than 2
                    .map(shift => shift.id); // Collect shift ids
                    selectAll.value = true;
            }
        };


        const selectAllText = computed(() => {
            return selectAll.value ? "Unselect All" : "Select All";
        });

        const dialog = ref({
        dialogVisible: false,
        data: {},
        cancel: {
            reasonType: null,
            options: [
            { label: "Change in availability", value: 1 },
            { label: "Other...", value: 3 },
            ],
            description: null,
        },
        });

        const getCancellationReason = () => {
        if (dialog.value.cancel.reasonType === 3) {
            return dialog.value.cancel.description;
        }
        return dialog.value.cancel.options[dialog.value.cancel.reasonType - 1]
            .label;
        };

        const removeButtonDisabled = computed(() => {
            if (
                dialog.value.cancel.reasonType &&
                dialog.value.cancel.reasonType !== 3 && selectedShifts.value.length > 0
            )
                return false;
            if (
                dialog.value.cancel.reasonType === 3 &&
                dialog.value.cancel.description && selectedShifts.value.length > 0
            )
                return false;
            return true;
        });

      

        const toggleBulkShiftSelect = (isChecked) => {
          if(userRole === 'pharmacy'){
            return;

          }else{
          const totalSelectableShifts = job.value.shifts
            .filter(shift =>!isShiftDisabled(shift.status))
            .map(shift => shift.id);

          if (isChecked) {
            // If any checkbox is checked, select all valid shifts
            selectedShifts.value = totalSelectableShifts;
            selectAll.value = true;
          } else {
            // If any checkbox is unchecked, clear all selections
            selectedShifts.value = [];
            selectAll.value = false;
          }
        }
        };

        const isShiftDisabled = (status) => {
          return status !== 0 && status !== 1 && status !== 15;
        };

        return {
            closeModal,
            modalVisible,
            openModal,
            checkJobDateStart,
            job,
            shift,
            bottomDropUp,
            dialogTitle,
            userData,
            userRole,
            bottomDropUpClose,
            actions,
            selectedShifts,
            searchTerm,
            clearSearchTerm,
            showShiftInformation,
            Rate,
            confirmedHours,
            getTimeFromMinutes,
            travelCompensationCount,
            Sum,
            totalSuperRate,
            formatCurrency,
            isSelected,
            // handleCheckboxChange,
            toggleSelectAll,
            selectAllText,
            // areAllSelected,
            selectAll,
            dialog,
            getCancellationReason,
            removeButtonDisabled,
            selectedShiftPass,
            formatDate,
            toggleBulkShiftSelect,
            isAustralia,
            isShiftDisabled
        };
    },
};
</script>
